/**
 *
 * Mixin
 *
 */

export const VideoMixin = {
  name: 'VideoMixin',

  props: {
    video: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    c_bulletId() {
      return this.video.bulletId;
    },
  },
};
